import { FaqWrapper } from '@components/woz-check/Faq/styles'
import styled from '@emotion/styled'

export const PlainContentWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'noMargin',
})<{ noMargin?: boolean }>(({ theme, noMargin }) => ({
  background: 'white',
  color: theme.colors.N400,
  marginBottom: noMargin ? 0 : 64,
  '& h1, & h2': {
    fontSize: theme.fontSizes.desktop.h1,
    lineHeight: 1.25,
    marginTop: 24,
    marginBottom: 20,
    '&:first-child': {
      marginTop: 0,
    },
  },
  '& h3': {
    fontWeight: theme.fontWeights.semibold,
    fontSize: theme.fontSizes.desktop.h2,
    lineHeight: 1.35,
    marginBottom: 8,
    marginTop: 24,
    '&:first-child': {
      marginTop: 0,
    },
  },
  '& p, li': {
    fontSize: theme.fontSizes.desktop.body,
    lineHeight: 2,
  },
  '& img': {
    maxWidth: '100%',
    height: 'auto',
  },
  '& > p': {
    'a:not(.btn)': {
      color: theme.colors.B300
    },
    img: {
      borderRadius: 12,
    }
  },
  // "& > *:not(:last-child)": {
  //     marginBottom: 24
  // },
  [theme.breakpoint.down('md')]: {
    marginBottom: 32,
    '& h2': {
      fontSize: theme.fontSizes.mobile.h1,
      lineHeight: 1.2,
    },
    '& h3': {
      fontSize: theme.fontSizes.mobile.h2,
      lineHeight: 1.715,
    },
    '& h4': {
      lineHeight: 1.715,
    },
    '& p, li': {
      fontSize: theme.fontSizes.mobile.body,
      lineHeight: 1.667,
    },
    '& > *:not(:last-child)': {
      marginBottom: 24,
    },
  },
  [`& + ${FaqWrapper}`]: {
    marginTop: -16,
    marginBottom: 16,
    [theme.breakpoint.up('md')]: {
      marginTop: -40,
    },
  },
}))
